import { ServerResponse } from './server-response.model';

export class SocialLoginModel {
  accessToken: string;
  uid: string;
  originAccount: SocialLoginEnum;
  profile?: SocialProfile;
}

export enum SocialLoginEnum {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
}

export class SocialProfile {
  email: string;
  name: string;
}

export class SocialLoginResponseModel extends ServerResponse {
  response: Response;
}

class Response {
  application: ApplicationsEnum;
  username: string;
  email: string;
  image: string;
}

export enum ApplicationsEnum {
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  BROKER = 'BROKER',
  BROKERLEADER = 'BROKERLEADER',
  CLIENT = 'CLIENT',
}
